






































































































































import { Component, Vue } from 'vue-property-decorator'
import { getColors, getStyles, postColors, postStyles } from '../utils/http-client/constants'
import MessageBus from '../utils/buses/MessageBus'

@Component
export default class DesignersView extends Vue {
  private isLoading: boolean = true
  private error: string = ''
  private color: string = ''
  private colors: string[] = []
  private colorList: Object[] = []
  private styleList: Object[] = []
  private style: string = ''
  private styles: string[] = []
  private isSubmitting: boolean = false

  async created () {
    try {
      this.getConstants()
    } catch (err) {
      console.log(err)
    } finally {
      this.isLoading = false
    }
  }

  private async getConstants () {
    this.colorList = await getColors()
    this.styleList = await getStyles()
  }

  private async addColor () {
    this.colors.push(this.color)
    this.color = ''
  }

  private async addStyle () {
    this.styles.push(this.style)
    this.style = ''
  }

  private async onSubmit (constantToSubmit: string) {
    this.isSubmitting = true
    try {
      if (constantToSubmit === 'Colors') {
        await postColors(this.colors)
        this.colors = []
      }
      if (constantToSubmit === 'Styles') {
        await postStyles(this.styles)
        this.styles = []
      }
      MessageBus.sendMessage(`${constantToSubmit} successfully added.`, 'success')
      this.getConstants()
    } catch (err) {
      console.error('Designer Sign Up Error', err)
      MessageBus.sendMessage('Error with your request', 'error')
    } finally {
      this.isSubmitting = false
    }
  }
}
